"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The GetMediaAccessibilityViewResult model module.
 * @module model/GetMediaAccessibilityViewResult
 * @version 1.1.3-alpha.1
 */
class GetMediaAccessibilityViewResult {
  /**
   * Constructs a new <code>GetMediaAccessibilityViewResult</code>.
   * @alias module:model/GetMediaAccessibilityViewResult
   */
  constructor() {
    GetMediaAccessibilityViewResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>GetMediaAccessibilityViewResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GetMediaAccessibilityViewResult} obj Optional instance to populate.
   * @return {module:model/GetMediaAccessibilityViewResult} The populated <code>GetMediaAccessibilityViewResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GetMediaAccessibilityViewResult();
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('media_id')) {
        obj['media_id'] = _ApiClient.default.convertToType(data['media_id'], 'String');
      }
      if (data.hasOwnProperty('report_visible')) {
        obj['report_visible'] = _ApiClient.default.convertToType(data['report_visible'], 'Boolean');
      }
      if (data.hasOwnProperty('report_visible_without_override')) {
        obj['report_visible_without_override'] = _ApiClient.default.convertToType(data['report_visible_without_override'], 'Boolean');
      }
      if (data.hasOwnProperty('report_unlocked')) {
        obj['report_unlocked'] = _ApiClient.default.convertToType(data['report_unlocked'], 'Boolean');
      }
      if (data.hasOwnProperty('report_unlocked_without_override')) {
        obj['report_unlocked_without_override'] = _ApiClient.default.convertToType(data['report_unlocked_without_override'], 'Boolean');
      }
      if (data.hasOwnProperty('webinar_unlocked')) {
        obj['webinar_unlocked'] = _ApiClient.default.convertToType(data['webinar_unlocked'], 'Boolean');
      }
      if (data.hasOwnProperty('webinar_unlocked_without_override')) {
        obj['webinar_unlocked_without_override'] = _ApiClient.default.convertToType(data['webinar_unlocked_without_override'], 'Boolean');
      }
      if (data.hasOwnProperty('report_visible_by_override')) {
        obj['report_visible_by_override'] = _ApiClient.default.convertToType(data['report_visible_by_override'], 'Boolean');
      }
      if (data.hasOwnProperty('report_unlocked_by_override')) {
        obj['report_unlocked_by_override'] = _ApiClient.default.convertToType(data['report_unlocked_by_override'], 'Boolean');
      }
      if (data.hasOwnProperty('full_report_available_by_plan')) {
        obj['full_report_available_by_plan'] = _ApiClient.default.convertToType(data['full_report_available_by_plan'], 'Boolean');
      }
      if (data.hasOwnProperty('full_report_unlocked_by_plan')) {
        obj['full_report_unlocked_by_plan'] = _ApiClient.default.convertToType(data['full_report_unlocked_by_plan'], 'Boolean');
      }
      if (data.hasOwnProperty('full_report_unlocked_by_action')) {
        obj['full_report_unlocked_by_action'] = _ApiClient.default.convertToType(data['full_report_unlocked_by_action'], 'Boolean');
      }
      if (data.hasOwnProperty('webinar_unlocked_by_plan')) {
        obj['webinar_unlocked_by_plan'] = _ApiClient.default.convertToType(data['webinar_unlocked_by_plan'], 'Boolean');
      }
      if (data.hasOwnProperty('webinar_unlocked_by_action')) {
        obj['webinar_unlocked_by_action'] = _ApiClient.default.convertToType(data['webinar_unlocked_by_action'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>GetMediaAccessibilityViewResult</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GetMediaAccessibilityViewResult</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['media_id'] && !(typeof data['media_id'] === 'string' || data['media_id'] instanceof String)) {
      throw new Error("Expected the field `media_id` to be a primitive type in the JSON string but got " + data['media_id']);
    }
    return true;
  }
}

/**
 * @member {String} customer_id
 */
GetMediaAccessibilityViewResult.prototype['customer_id'] = undefined;

/**
 * @member {String} media_id
 */
GetMediaAccessibilityViewResult.prototype['media_id'] = undefined;

/**
 * @member {Boolean} report_visible
 */
GetMediaAccessibilityViewResult.prototype['report_visible'] = undefined;

/**
 * @member {Boolean} report_visible_without_override
 */
GetMediaAccessibilityViewResult.prototype['report_visible_without_override'] = undefined;

/**
 * @member {Boolean} report_unlocked
 */
GetMediaAccessibilityViewResult.prototype['report_unlocked'] = undefined;

/**
 * @member {Boolean} report_unlocked_without_override
 */
GetMediaAccessibilityViewResult.prototype['report_unlocked_without_override'] = undefined;

/**
 * @member {Boolean} webinar_unlocked
 */
GetMediaAccessibilityViewResult.prototype['webinar_unlocked'] = undefined;

/**
 * @member {Boolean} webinar_unlocked_without_override
 */
GetMediaAccessibilityViewResult.prototype['webinar_unlocked_without_override'] = undefined;

/**
 * @member {Boolean} report_visible_by_override
 */
GetMediaAccessibilityViewResult.prototype['report_visible_by_override'] = undefined;

/**
 * @member {Boolean} report_unlocked_by_override
 */
GetMediaAccessibilityViewResult.prototype['report_unlocked_by_override'] = undefined;

/**
 * @member {Boolean} full_report_available_by_plan
 */
GetMediaAccessibilityViewResult.prototype['full_report_available_by_plan'] = undefined;

/**
 * @member {Boolean} full_report_unlocked_by_plan
 */
GetMediaAccessibilityViewResult.prototype['full_report_unlocked_by_plan'] = undefined;

/**
 * @member {Boolean} full_report_unlocked_by_action
 */
GetMediaAccessibilityViewResult.prototype['full_report_unlocked_by_action'] = undefined;

/**
 * @member {Boolean} webinar_unlocked_by_plan
 */
GetMediaAccessibilityViewResult.prototype['webinar_unlocked_by_plan'] = undefined;

/**
 * @member {Boolean} webinar_unlocked_by_action
 */
GetMediaAccessibilityViewResult.prototype['webinar_unlocked_by_action'] = undefined;
var _default = GetMediaAccessibilityViewResult;
exports.default = _default;